
import Vue from 'vue';
import Component from 'vue-class-component';
import { SkillModel } from '@/models/skill.model';
import { Emit, PropSync, Ref } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { userModule, userState } from '@/utils/store-acessor';
import { ProfileContestantModel, UserModel } from '@/models/user.model';
import SkillsSelector from '@/components/Shared/SkillsSelector.vue';
import PopupSkillSave from '@/components/Popups/PopupSkillSave.vue';

@Component({
  components: { SkillsSelector, PopupSkillSave }
})
export default class ProfileSkillsConfig extends Vue {
  @Action('requestAllSkills') fetchSkills: any;
  @userModule.Getter('user') user!: UserModel;
  @userModule.Getter('user_id') userId!: number;
  @userModule.Getter('contestant') contestant!: ProfileContestantModel;
  // @ts-ignore
  @Ref() skillsForm: VForm;
  valid = false;
  selectedSkills: number[] = [];
  showLoading = false;
  @PropSync('dialog', { required: true, default: false })
  completeProfileDialog!: boolean;
  submitting: boolean = false;

  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = '';
  buttonTrigger: boolean = false;

  mounted() {
    this.fetchSkills();

    const skills = this.contestant?.skills?.map(({ id }) => id);
    if (skills) {
      try {
        this.selectedSkills = skills as number[];
      } catch (ignore) {
        this.selectedSkills = [];
      }
    }
  }

  TogglePopup(){
    this.buttonTrigger = false;
  }

  async onSubmit() {
    if (this.skillsForm.validate()) {
      try {
        this.submitting = true;
        await userState.setSkills(this.selectedSkills);
        this.buttonTrigger = true;
        // this.snackbarVisibility = true;
        // this.snackbarColor = 'green';
        // this.snackbarText = 'profile.messages.update_success';
      } catch (error) {
        this.snackbarVisibility = true;
        this.snackbarColor = 'red';
        this.snackbarText = 'profile.messages.update_failed';
      } finally {
        this.submitting = false;
      }
    } else {
      this.snackbarVisibility = true;
      this.snackbarColor = 'red';
      this.snackbarText = 'profile.messages.update_failed';
    }
  }

  skillAlreadySelected(skill: SkillModel): boolean {
    if (!skill.id) {
      return false;
    }

    return this.selectedSkills.includes(skill.id);
  }

  addSkill(skill: SkillModel) {
    if (skill.id == undefined) {
      return;
    }
    if (this.skillAlreadySelected(skill)) {
      const index = this.selectedSkills.indexOf(skill.id);
      this.selectedSkills.splice(index, 1);
    } else {
      this.selectedSkills.push(skill.id);
    }
  }

  @Emit()
  completeMyProfile() {
    this.completeProfileDialog = false;
    return;
  }
}
